import { font, query } from '@design/templateFns';
import { FC } from 'react';
import styled from 'styled-components';

export interface StatisticProps {
  statNumber: number;
  subheader: string;
  prepend?: string;
  append?: string;
}

export const Statistic: FC<StatisticProps> = ({ statNumber, subheader, prepend, append }) => {
  return (
    <StatisticWhole>
      <StatisticWrapper>
        {prepend && <StatisticPrependAppend>{prepend}</StatisticPrependAppend>}
        <StatisticNumber>{statNumber}</StatisticNumber>
        {append && <StatisticPrependAppend>{append}</StatisticPrependAppend>}
      </StatisticWrapper>
      <StatisticLabel>{subheader}</StatisticLabel>
    </StatisticWhole>
  );
};

// Styling
const StatisticWhole = styled.div`
  text-align: center;
`;

const StatisticWrapper = styled.span`
  ${font('headline-md')};

  @media screen and (${query.atLeast('desktop')}) {
    ${font('headline-xl')};
  }
`;

const StatisticNumber = styled.span``;

const StatisticPrependAppend = styled.span``;

const StatisticLabel = styled.div`
  ${font('body-sm')};

  @media screen and (${query.atLeast('desktop')}) {
    ${font('body-lg')};
  }
`;
